'use strict';

//region D3 import
import * as format from 'd3-format';
//endregion

//region React
import React from 'react';
//endregion

const CandidateLabels = (props) => {
  format.formatDefaultLocale(props.locale);
  const percentageFormat = format.format('.1%');
  return (
    <div className="ui tiny two statistics">{props.wantedCandidates.map((name) => {
      let object = props.lastValues[name];
      return (
        <div className={`${object.color} statistic`} key={name}>
          <div className="value"><img src={`//interaktiv.tagesanzeiger.ch/static/2016/us-elections/${object.last_name.toLocaleLowerCase()}-simple.png`} alt="" className="ui mini centered bordered avatar inline image" /> {percentageFormat(object.value/100)}</div>
          <div className={`label`}>
            {object.first_name}&nbsp;{object.last_name}
          </div>

        </div>
      )
    })}</div>
  )
};

CandidateLabels.propTypes = {
  wantedCandidates: React.PropTypes.arrayOf(React.PropTypes.string).isRequired
};
CandidateLabels.defaultProps = {
  wantedCandidates: []
};

export default CandidateLabels;



/** WEBPACK FOOTER **
 ** ./src/components/candidateLabels/CandidateLabels.js
 **/